import React from "react";
import { Box, IconButton, useTheme } from "@mui/material";
import CustomTypography from "../../../../../views/components/common/form/CustomTypography";
import {
  DesktopWindows as DesktopIcon,
  Tablet as TabletIcon,
  PhoneAndroid as MobileIcon,
} from "@mui/icons-material";

interface LivePreviewWrapperProps {
  deviceView: "desktop" | "tablet" | "mobile";
  onDeviceViewChange: (view: "desktop" | "tablet" | "mobile") => void;
  children: React.ReactNode;
  previewWidth: string;
}

const LivePreviewWrapper: React.FC<LivePreviewWrapperProps> = ({
  deviceView,
  onDeviceViewChange,
  children,
  previewWidth,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            pl: 3,
            pr: 3,
            pt: 2,
            pb: 2,
            backgroundColor: theme.palette.customColors.white,
          }}
        >
          <CustomTypography
            variant="heading7"
            fontWeight={600}
            sx={{ color: theme.palette.customColors.greyTextColor }}
          >
            Live Preview
          </CustomTypography>

          <Box
            sx={{
              display: "flex",
              gap: 0.5,
              backgroundColor: theme.palette.customColors.lightGray,
              borderRadius: "8px",
              p: 0.5,
            }}
          >
            <IconButton
              onClick={() => onDeviceViewChange("desktop")}
              sx={{
                backgroundColor:
                  deviceView === "desktop"
                    ? theme.palette.customColors.white
                    : "transparent",
                color:
                  deviceView === "desktop"
                    ? theme.palette.customColors.blackText
                    : theme.palette.customColors.greyTextColor,
                borderRadius: "6px",
                boxShadow:
                  deviceView === "desktop"
                    ? "0 1px 2px rgba(0,0,0,0.1)"
                    : "none",
                "&:hover": {
                  backgroundColor:
                    deviceView === "desktop"
                      ? theme.palette.customColors.white
                      : "rgba(255,255,255,0.5)",
                },
              }}
            >
              <DesktopIcon fontSize="small" />
            </IconButton>
            <IconButton
              onClick={() => onDeviceViewChange("tablet")}
              sx={{
                backgroundColor:
                  deviceView === "tablet"
                    ? theme.palette.customColors.white
                    : "transparent",
                color:
                  deviceView === "tablet"
                    ? theme.palette.customColors.blackText
                    : theme.palette.customColors.grayText,
                borderRadius: "6px",
                boxShadow:
                  deviceView === "tablet"
                    ? "0 1px 2px rgba(0,0,0,0.1)"
                    : "none",
                "&:hover": {
                  backgroundColor:
                    deviceView === "tablet"
                      ? "#FFFFFF"
                      : "rgba(255,255,255,0.5)",
                },
              }}
            >
              <TabletIcon fontSize="small" />
            </IconButton>
            <IconButton
              onClick={() => onDeviceViewChange("mobile")}
              sx={{
                backgroundColor:
                  deviceView === "mobile"
                    ? theme.palette.customColors.white
                    : "transparent",
                color:
                  deviceView === "mobile"
                    ? theme.palette.customColors.blackText
                    : theme.palette.customColors.grayText,
                borderRadius: "6px",
                boxShadow:
                  deviceView === "mobile"
                    ? "0 1px 2px rgba(0,0,0,0.1)"
                    : "none",
                "&:hover": {
                  backgroundColor:
                    deviceView === "mobile"
                      ? "#FFFFFF"
                      : "rgba(255,255,255,0.5)",
                },
              }}
            >
              <MobileIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor: theme.palette.customColors.grayBackGroundColor,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              maxWidth: "100%",
              px: { xs: 1, sm: 2, lg: 0 },
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: previewWidth,
                maxWidth: "100%",
                backgroundColor: theme.palette.customColors.white,
                borderRadius: "8px",
                boxShadow: `0 4px 12px ${theme.palette.customColors.shadowMedium}`,
                overflow: "auto",
                minWidth: 0,
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LivePreviewWrapper;
